module.exports = __webpack_public_path__ + "static/media/fire-white.de5ffe0d.svg";